<template>
  <div class="translations-list">
    <div v-for="(value, key) in translations" :key="key" class="translation">
      <div class="is-pulled-left">
        <span>{{key}}</span><span v-if="key === 'pt'"> (padrão)</span>
      </div>
      <div class="is-pulled-right" style="margin-right: 10px">
        <slot
          :place="value"
          :lang="key"
        ></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TranslationsList',
  props: {
    translations: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>

<style lang="scss">
.translations-list {
  .translation {
    overflow: hidden;
    padding: 10px 0;
    &+.translation {
      border-top: 1px solid #efefef;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TranslationsList.vue